import React, { useState, useEffect, useRef } from 'react'
import Doughnuts from '../../components/generals/charts/doughnut'
import Pie from '../../components/generals/charts/pie'
import BoxChart from '../../components/generals/boxCharts'
import KnobChart from '../../components/generals/charts/knob'
import Mapa from '../../components/generals/map'
import { getData, putData } from '../../actions/servicesHttp'
import Header from '../../components/generals/header'
import { ProgressSpinner } from 'primereact/progressspinner'
import store from '../../reducer/store'
import styles from '../../css/Home.module.css'
import stylesIndex from '../../css/Index.module.css'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import ToggleButton from 'react-bootstrap/ToggleButton'
import VerticalBar from '../../components/generals/charts/verticalBar'
import { Dropdown } from 'primereact/dropdown'
import { Toast } from 'primereact/toast'
import formatUseTimeApps from './Assets/formatUseTimeApps'
import { formatDate, formatDateDenunciations } from '../../components/generals/charts/utils/DatesFormats'
import DevicesUseTimeChart from '../../components/Dashboards/Devices/DevicesUseTimeChart'
import formatDevicesConnections from './Assets/formatDevicesConnections'
import { useTranslation } from 'react-i18next'
import { NavLink, useNavigate } from 'react-router-dom'

export default function Home () {
  const [urlStat] = useState('stats')
  const [urlConn] = useState('connections')
  const [urlMap] = useState('locations')
  const [urlMissingDevices] = useState('missingDevices')
  const [urlNotifications] = useState('notifications')
  const [urlAppsUseTime] = useState('applications/mostUsedApplications')
  const [urlDevicesUseTime] = useState('devicesUseTime')
  const [urlDevicesConnections] = useState('home/connections')
  const [loadingCharts, setLoadingCharts] = useState(false)
  const [loadingStats, setLoadingStats] = useState(false)
  const [loadingAppsUseTime, setLoadingAppsUseTime] = useState(false)
  const [loadingMissingDevices, setLoadingMissingDevices] = useState(false)
  const [loadingDevicesUseTime, setLoadingDevicesUseTime] = useState(false)
  const [loadingDevicesConnections, setLoadingDevicesConnections] = useState(false)

  const [charts, setCharts] = useState(null)
  const [stats, setStats] = useState(null)
  const [map, setMap] = useState(null)
  const [appsUseTime, setAppsUseTime] = useState(null)
  const [dateFilter, setDateFilter] = useState(8)
  const [dateFilterDC, setDateFilterDC] = useState(8)
  const [dateFilterUT, setDateFilterUT] = useState(7)
  const [category, setCategory] = useState(5)
  const [notifications, setNotifications] = useState(null)
  const [missingDevices, setMissingDevices] = useState(null)
  const [devicesUseTime, setDevicesUseTime] = useState(null)
  const [devicesConnections, setDevicesConnections] = useState(null)

  const { user } = store.getState()
  const role = user.roles
  const toast = useRef(null)
  const { t } = useTranslation('home')
  const navigate = useNavigate()

  // Filtro de fecha
  const dates = [
    { name: t('boxChart6.button1'), value: 8 },
    { name: t('boxChart6.button2'), value: 31 }
  ]

  // Filtro de fecha Devices Connections
  const datesDC = [
    { name: t('boxChart7.button1'), value: 8 },
    { name: t('boxChart7.button2'), value: 31 }
  ]

  // Filtro de fecha Devices Use Time
  const datesUT = [
    { name: t('boxChart5.button1'), value: 7 },
    { name: t('boxChart5.button2'), value: 0 }
  ]

  // Categorias
  const [categories] = useState([
    { name: t('boxChart6.category1'), id: 0 },
    { name: t('boxChart6.category2'), id: 1 },
    { name: t('boxChart6.category3'), id: 2 },
    { name: t('boxChart6.category4'), id: 3 },
    { name: t('boxChart6.category5'), id: 4 },
    { name: t('boxChart6.category6'), id: 5 },
    { name: t('boxChart6.category7'), id: 6 },
    { name: t('boxChart6.category8'), id: 7 }
  ])

  const getDataCharts = async (conn) => {
    setLoadingCharts(true)
    const data = await getData('home', conn, navigate)
    if (data) setCharts(data?.data)
    else setCharts([])
    setLoadingCharts(false)
  }

  const getDataStats = async (stat) => {
    setLoadingStats(true)
    const data = await getData('home', stat, navigate)
    if (data) setStats(data?.data)
    else setStats([])
    setLoadingStats(false)
  }

  const getDataMap = async (loc) => {
    const data = await getData('home', loc, navigate)
    if (data) setMap(data.data)
  }

  const getDataAppsUseTime = async (url, params) => {
    setLoadingAppsUseTime(true)
    const data = await getData(url, JSON.stringify(params), navigate)
    // console.log(data)
    if (data) {
      const res = formatUseTimeApps(data?.data, dateFilter, 3600)
      setAppsUseTime(res)
    } else {
      setAppsUseTime({
        labels: [],
        data: []
      })
    }
    setLoadingAppsUseTime(false)
  }

  const getNotifications = async (url) => {
    const res = await getData(url, undefined, navigate)
    if (res.status === 200) {
      setNotifications(res.data)
    }
  }

  const getDataMissingDevices = async (url) => {
    setLoadingMissingDevices(true)
    const data = await getData('home', url, navigate)
    if (data) setMissingDevices(data?.data)
    else setMissingDevices([])
    setLoadingMissingDevices(false)
  }

  const getDevicesUseTime = async (url, filter) => {
    setLoadingDevicesUseTime(true)
    const data = await getData(url, filter, navigate)
    if (data) setDevicesUseTime(data?.data)
    else setDevicesUseTime([])
    setLoadingDevicesUseTime(false)
  }

  const getDevicesConnections = async (url, chart, days) => {
    setLoadingDevicesConnections(true)
    const data = await getData(url, `${chart}/${days}`, navigate)
    if (data) {
      const res = formatDevicesConnections(data?.data, dateFilterDC)
      setDevicesConnections(res)
    } else {
      setDevicesConnections([{
        labels: [],
        data: []
      }])
    }
    setLoadingDevicesConnections(false)
  }

  // <NavLink to="/mdm/reports"></NavLink>

  const showMultiple = async (data) => {
    const array = []
    const idsConnections = []
    let item

    if (data?.length > 0) {
      data.forEach(element => {
        if (element.type === 'missingDevicesConnection') {
          item = {
            severity: 'info',
            summary: 'Sticky',
            sticky: true,
            content: () => (
              <p>{t('missingDeviceMessages.one')} <NavLink to={`/mdm/device/${element.deviceId}`}>{element.device.serial_number}</NavLink> {t('missingDeviceMessages.two')} {formatDate(element.date)}, {t('missingDeviceMessages.three')} {element.device.ip_wan} . <NavLink to="/mdm/reports/missing-devices-report">{t('missingDeviceMessages.four')}</NavLink></p>
            )
          }
        } else if (element.type === 'deviceActivation') {
          item = {
            severity: 'info',
            summary: 'Sticky',
            sticky: true,
            content: () => (
              <p>{t('deviceActivationMessages.one')} <NavLink to={`/mdm/device/${element.deviceId}`}>{element.device.serial_number}</NavLink> {t('deviceActivationMessages.two')} {formatDate(element.date)}, {t('deviceActivationMessages.three')} {element.device.ip_wan} . <NavLink to="/mdm/reports/devices-report">{t('deviceActivationMessages.four')}</NavLink></p>
            )
          }
        } else if (element.type === 'lease') {
          item = {
            severity: 'info',
            summary: 'Sticky',
            sticky: true,
            content: () => (
              <p>{t('leaseMessages.one')} <NavLink to={`/mdm/device/${element.deviceId}`}>{element.device.serial_number}</NavLink> {t('leaseMessages.two')} {element.data.diff > 1 ? element.data.diff + t('leaseMessages.four') : element.data.diff + t('leaseMessages.three')} . {t('leaseMessages.five')} {formatDateDenunciations(element.data.lease.endDate)}. <NavLink to={`/mdm/group/${element.data.groupId}`}>{t('leaseMessages.six')}</NavLink></p>
            )
          }
        }
        idsConnections.push(element.id)
        array.push(item)
      })

      if (array.length > 0) {
        toast.current.show(array)
        const response = await putData(urlNotifications, idsConnections, navigate)

        console.log(response)
      }
    }
  }

  useEffect(() => {
    getDataStats(urlStat)
  }, [urlStat])

  useEffect(() => {
    getDataCharts(urlConn)
  }, [urlConn])

  useEffect(() => {
    getDataMap(urlMap)
  }, [urlMap])

  useEffect(() => {
    getNotifications(urlNotifications)
  }, [urlNotifications])

  useEffect(() => {
    getDataMissingDevices(urlMissingDevices)
  }, [urlMissingDevices])

  useEffect(() => {
    getDevicesConnections(urlDevicesConnections, 'allConnections', dateFilterDC)
  }, [urlDevicesConnections, dateFilterDC])

  useEffect(() => {
    if (role?.homePage?.notificationsHome) {
      showMultiple(notifications)
    }
  }, [notifications, role])

  useEffect(() => {
    const json = {
      groupApp: category,
      dateFilter,
      view: 'home'
    }

    getDataAppsUseTime(urlAppsUseTime, json)
  }, [urlAppsUseTime, category, dateFilter])

  useEffect(() => {
    let startDate = new Date()
    startDate = startDate.setDate(startDate.getDate() - dateFilterUT)
    startDate = new Date(startDate)?.toISOString().split('T')[0]

    let endDate = new Date()
    endDate = dateFilter === 0 ? endDate.setDate(endDate.getDate() - 0) : endDate.setDate(endDate.getDate() - 1)
    endDate = new Date(endDate)?.toISOString().split('T')[0]

    const date = startDate + ',' + endDate
    getDevicesUseTime(urlDevicesUseTime, `${date}/${null}`)
  }, [urlDevicesUseTime, dateFilterUT])

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
          <Toast ref={toast} />
          <Header title={t('title')} />
          <div className={styles.spaceCharts}>
            {role.homePage.diskChartHome && <BoxChart
              heightBody="80%"
              height="25rem"
              title={t('boxChart1.title')}
              icon="fa-solid fa-floppy-disk"
              className={`${styles.boxChart}`}
            >
              {loadingStats && <ProgressSpinner />}
              {stats && stats?.percentageDisk !== null && (
                <Pie data={stats} type="general"/>
              )}
              {stats && stats?.percentageDisk === null && <h5>{t('nullData')}</h5>}
            </BoxChart>}
            {role.homePage.ramChartHome && <BoxChart
              heightBody="80%"
              height="25rem"
              title={t('boxChart2.title')}
              icon="fa-solid fa-memory"
              className={`${styles.boxChart}`}
            >
              {loadingStats && <ProgressSpinner />}
              {stats && stats?.percentageRam !== null && (
                <KnobChart data={stats} type="general" size={210} />
              )}
              {stats && stats?.percentageRam === null && <h5>{t('nullData')}</h5>}
            </BoxChart>}
            {role.homePage.connectionsChartHome && <BoxChart
              heightBody="80%"
              height="25rem"
              title={t('boxChart3.title')}
              icon="pi pi-tablet"
              className={`${styles.boxChart}`}
            >
              {loadingCharts && <ProgressSpinner />}
              {charts && charts?.total !== 0 && (
                <Doughnuts
                  data={charts}
                  type='connections'
                />
              )}
              {charts && charts?.total === 0 && <h5>{t('nullData')}</h5>}
            </BoxChart>}
            {role.homePage.missingDevicesChartHome && <BoxChart
              heightBody="80%"
              height="25rem"
              title={t('boxChart4.title')}
              icon="pi pi-tablet"
              className={`${styles.boxChart}`}
            >
              {loadingMissingDevices && <ProgressSpinner />}
              {missingDevices && missingDevices?.total !== 0 && (
                <Doughnuts
                  data={missingDevices}
                  type='missingDevices'
                />
              )}
              {charts && charts?.total === 0 && <h5>S{t('nullData')}</h5>}
            </BoxChart>}
            {role.homePage.devicesUseTimeChartHome && <BoxChart
              heightBody="80%"
              height="25rem"
              title={t('boxChart5.title')}
              icon="pi pi-tablet"
              className={`${styles.boxChart}`}
              flexDirection="column"
              position="relative"
            >
              <ButtonGroup className={styles.dateFilterContainerUT}>
                  {datesUT.map((element, i) => (
                    <ToggleButton
                      key={i}
                      id={`dateUT-home-${i}`}
                      type="radio"
                      variant="secondary"
                      name="dateUT-home"
                      value={element.value}
                      checked={element.value === dateFilterUT}
                      className={styles.btnDateUseTimeApps}
                      onChange={(e) => setDateFilterUT(parseInt(e.target.value))}
                    >
                      {element.name}
                    </ToggleButton>
                  ))}
                </ButtonGroup>
                {loadingDevicesUseTime && <ProgressSpinner />}
                {devicesUseTime?.useTime === 0 && <h5>{t('nullData')}</h5>}
                {devicesUseTime?.useTime > 0 && <DevicesUseTimeChart
                  data={devicesUseTime}
                  filter={dateFilterUT}
                />}
            </BoxChart>}
          </div>
          <div className={styles.bodyHome}>
            {role.homePage.appsUseTimeChartHome && <BoxChart
                heightBody="80%"
                height="35rem"
                title={`${t('boxChart6.title')} ${categories[category]?.name}`}
                icon="fa-solid fa-shapes"
                className={`${styles.boxChart}`}
              >
                {loadingAppsUseTime && <ProgressSpinner />}
                {appsUseTime && appsUseTime?.data.length !== 0 && <>
                  <div className={styles.filters}>
                    <div className={styles.categoriesContainer}>
                      <p className={styles.floatLabel}>{t('boxChart6.label1')}</p>
                      <Dropdown
                        value={category}
                        options={categories}
                        onChange={(e) => setCategory(e.value)}
                        optionLabel="name"
                        optionValue="id"
                        placeholder={t('boxChart6.placeholder')}
                        className={styles.dropdown}
                      />
                    </div>
                    <ButtonGroup className={styles.dateFilterContainer}>
                      {dates.map((date, index) => (
                        <ToggleButton
                          key={index}
                          id={`date-home-${index}`}
                          type="radio"
                          variant="secondary"
                          name="date-home"
                          value={date.value}
                          checked={date.value === dateFilter}
                          className={styles.btnDateUseTimeApps}
                          onChange={(e) => setDateFilter(parseInt(e.target.value))}
                        >
                          {date.name}
                        </ToggleButton>
                      ))}
                    </ButtonGroup>
                  </div>
                  <VerticalBar title={t('boxChart6.label2')} labels={appsUseTime?.labels} data={appsUseTime?.data} backgroundColor='#3F9BFF'className={ `${styles.marginTop}`}/>
                </>}
                {appsUseTime && appsUseTime?.data.length === 0 && <h5>{t('nullData')}</h5>}
              </BoxChart>}
              {role.homePage.devicesConnectionsChartHome && <BoxChart
                heightBody="80%"
                height="35rem"
                title={t('boxChart7.title')}
                icon="fa-solid fa-mobile"
                className={`${styles.boxChart}`}
                flexDirection="column"
                position="relative"
              >
                <ButtonGroup className={styles.dateFilterContainerUT}>
                  {datesDC.map((el, it) => (
                    <ToggleButton
                      key={it}
                      id={`dateDC-home-${it}`}
                      type="radio"
                      variant="secondary"
                      name="dateDC-home"
                      value={el.value}
                      checked={el.value === dateFilterDC}
                      className={styles.btnDateUseTimeApps}
                      onChange={(e) => setDateFilterDC(parseInt(e.target.value))}
                    >
                      {el.name}
                    </ToggleButton>
                  ))}
                </ButtonGroup>
                {loadingDevicesConnections && <ProgressSpinner />}
                {devicesConnections?.data?.length === 0 && <h5>{t('nullData')}</h5>}
                {devicesConnections?.data?.length > 0 && <VerticalBar title={t('boxChart7.label1')} labels={devicesConnections?.labels} data={devicesConnections?.data} backgroundColor='#3F9BFF' className={ `${styles.marginTop}`}/>}
              </BoxChart>}
          </div>
            {role.homePage.locationMapHome && <BoxChart
                heightBody="80%"
                icon="pi pi-map-marker"
                height="35rem"
                title={t('boxChart8.title')}
              >
                {!map ? <ProgressSpinner /> : <Mapa info={map} />}
              </BoxChart>}
      </div>
    </div>
  )
}
